import type { RouteRecordRaw } from 'vue-router';
import { BlankLayout } from '@shared/naive-ui';

export const debugRoutes = <RouteRecordRaw[]>[
  {
    name: 'debug',
    path: '/debug',
    component: () => import('./pages/DebugPage.vue'),
    meta: {
      layout: BlankLayout,
    },
  },
];
